import React from 'react';
import PropTypes from 'prop-types';
import {
  List as ReactAdminList,
  Datagrid,
} from 'react-admin';

const List = (props) => {
  const {
    children,
    rowStyle,
    rowClick,
    expand,
    actions,
    dataGridClasses,
    ...rest
  } = props;

  return (
    <ReactAdminList
      perPage={20}
      pagination={false}

      {...rest}
    >
      <Datagrid
        rowStyle={rowStyle}
        rowClick={rowClick}
        classes={dataGridClasses}
        expand={expand}
        bulkActionButtons={false}
        sx={{
                boxShadow: 2,
                border: 2,
                borderColor: 'primary',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
            }}
      >
        {children}
      </Datagrid>
    </ReactAdminList>
  );
};

List.propTypes = {
  children: PropTypes.node.isRequired,
  rowStyle: PropTypes.func,
  rowClick: PropTypes.string,
  expand: PropTypes.node,
  dataGridClasses: PropTypes.object,
};

List.defaultProps = {
  rowStyle: () => {},
  rowClick: null,
  expand: null,
  dataGridClasses: {},
};

export default List;
